module.exports = __webpack_public_path__ + "static/media/IconUser.5db9bf00.svg";